import Popover from '@mui/material/Popover';
import Typography from '@mui/material/Typography';
import { useState } from 'react';

const PopupWithIcon = ({ InfoDetails, icon = "fa-circle-info" }) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    const popupId = open ? 'simple-popover' : undefined;

    const handleClose = () => {
        setAnchorEl(null);
    };

    return (
        <>
            <i className={`fa ${icon} arrow px-1`} title={InfoDetails} ></i>
            {InfoDetails && (
                <Popover
                    id={popupId}
                    open={open}
                    anchorEl={anchorEl}
                    onClose={handleClose}
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'left',
                    }}
                    transformOrigin={{
                        vertical: 'top',
                        horizontal: 'left',
                    }}
                    PaperProps={{
                        style: {
                            width: 'auto',       
                            maxWidth: '20vw',    
                            padding: '10px',    
                            boxSizing: 'border-box', 
                            overflow: 'auto',  
                        },
                    }}
                >
                    <Typography
                        sx={{
                           // p: 1,
                            fontSize: '12px',
                            margin: '0 !important',
                            overflowY: 'auto',
                        }}
                    >
                        {InfoDetails}
                    </Typography>
                </Popover>
            )}
        </>
    );
};

export default PopupWithIcon;
